export default "__VITE_ASSET__CWB0dMkm__"